export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9320.01295d65.jpg";